import { serverTimestamp, type Timestamp } from 'firebase/firestore';

export function timestampToDate(value: Timestamp | undefined): Date {
  return value ? value.toDate() : new Date();
}

export function buildTimestampPayload(isNew: boolean): Record<string, unknown> {
  return {
    updatedAt: serverTimestamp(),
    ...(isNew ? { createdAt: serverTimestamp() } : {}),
  };
}
